export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const ms = Date.now() - new Date(iso).getTime();
  const m  = Math.floor(ms / 60_000);
  if (m < 1)  return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}

export function statusBadgeClass(status: string): string {
  const map: Record<string, string> = {
    browsing:         "badge-gray",
    pending_content:  "badge-blue",
    content_incomplete: "badge-orange",
    pending_rewrite:  "badge-blue",
    rewriting:        "badge-blue",
    pending_review:   "badge-yellow",
    approved:         "badge-green",
    rejected:         "badge-red",
    published:        "badge-green",
    dismissed:        "badge-gray",
    error:            "badge-red",
  };
  return map[status] ?? "badge-gray";
}

export function statusLabel(status: string): string {
  const map: Record<string, string> = {
    browsing:           "Browsing",
    pending_content:    "Fetching",
    content_incomplete: "Incomplete",
    pending_rewrite:    "Queued",
    rewriting:          "Rewriting",
    pending_review:     "Review",
    approved:           "Approved",
    rejected:           "Rejected",
    published:          "Published",
    dismissed:          "Dismissed",
    error:              "Error",
  };
  return map[status] ?? status;
}

export function truncate(text: string | null | undefined, max = 160): string {
  if (!text) return "";
  return text.length > max ? text.slice(0, max) + "…" : text;
}
